import firebase from "firebase/compat/app";
import { db } from "../firebase";

// Token de push de este dispositivo (fcmToken en el navegador, fcmTokenAndroid
// en la app) y en qué campo de users/{uid} quedó guardado. Al cerrar sesión se
// borra de esa cuenta para que sus notificaciones no le sigan llegando a este
// dispositivo cuando entra otra cuenta (ver usePushNotifications.js y la
// función dedupePushTokens, que lo saca del resto de las cuentas).
const KEY = "pushToken";

export const rememberPushToken = (field, token) => {
  try {
    localStorage.setItem(KEY, JSON.stringify({ field, token }));
  } catch (_) {
    // localStorage puede no estar disponible; no es crítico
  }
};

export const forgetPushToken = async (uid) => {
  let saved = null;
  try {
    saved = JSON.parse(localStorage.getItem(KEY) || "null");
  } catch (_) {
    saved = null;
  }
  if (!uid || !saved?.field || !saved?.token) return;
  try {
    const ref = db.doc(`users/${uid}`);
    const snap = await ref.get();
    // Solo si sigue siendo el de este dispositivo: otro puede haberlo pisado.
    if (snap.exists && snap.data()[saved.field] === saved.token) {
      await ref.update({ [saved.field]: firebase.firestore.FieldValue.delete() });
    }
  } catch (error) {
    console.error("No se pudo borrar el token de push al cerrar sesión:", error);
  }
};
